import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config.token';
import { AppConfig } from '../app-config';
import { FilterPresetDto } from '../models/dtos/filter-preset-dto';
import { AddFilterPresetRequest } from '../contracts/requests/add-filter-reset-request';
import { UpdateFilterPresetRequest } from '../contracts/requests/update-filter-preset-request';
import { SendActivationLink } from '../shared/models/send-activation-link';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private config = inject<AppConfig>(APP_CONFIG);

  private readonly API_URL = this.config.resourceApiURI;
  private readonly path = '/users';

  private get url() {
    return this.API_URL + this.path;
  }

  constructor() { }

  getFilterPresets(filterTypeId: number): Observable<FilterPresetDto[]> {
    const url = `${this.url}/filterPresets/${filterTypeId}`;
    return this.http.get<FilterPresetDto[]>(url)
      .pipe(map(res => res.map(item => ({
        ...item,
        Object: JSON.parse(item.Object)
      }))));
  }

  addFilterPreset(request: AddFilterPresetRequest): Observable<number> {
    const url = `${this.url}/filterPresets`;
    return this.http.post<number>(url, request);
  }

  updateFilterPreset(filterPresetId: number, request: UpdateFilterPresetRequest): Observable<void> {
    const url = `${this.url}/filterPresets/${filterPresetId}`;
    return this.http.put<any>(url, request);
  }

  selectFilterPreset(filterPresetId: number): Observable<void> {
    const url = `${this.url}/filterPresets/${filterPresetId}/select`;
    return this.http.patch<any>(url, undefined);
  }

  deselectFilterPreset(filterPresetId: number): Observable<void> {
    const url = `${this.url}/filterPresets/${filterPresetId}/deselect`;
    return this.http.patch<any>(url, undefined);
  }

  deleteFilterPreset(filterPresetId: number): Observable<any> {
    const url = `${this.url}/filterPresets/${filterPresetId}`;
    return this.http.delete<any>(url);
  }

  sendActivationLink(request: SendActivationLink): Observable<boolean> {
    const url = `${this.url}/sendActivationLink`;
    return this.http.post<boolean>(url, request);
  }
}
